import { ReactJSXElement } from "@emotion/react/types/jsx-namespace";
import Tooltip from "@mui/material/Tooltip";

import { SxProps, TableCell } from "@mui/material";
import { ReactElement } from "react";
import { GroupedTableColumn } from "./GroupedTable";
import { CellContentContainer, TextContainer } from "./styled";

interface Props {
  column: GroupedTableColumn;
  value: any;
  flairComponent?: ReactJSXElement;
  onClick?: () => void;
  index: number;
  disableSelectItems?: boolean;
}

interface GroupedTableCellContainerProps {
  children: ReactElement;
  align?: "left" | "center" | "right";
  width?: string;
  index: number;
  disableSelectItems?: boolean;
}

interface GroupedTableCellContainerProps {
  children: ReactElement;
  align?: "left" | "center" | "right";
  width?: string;
  index: number;
  sx?: SxProps;
  onClick: () => void;
  disableSelectItems?: boolean;
}

const GroupedTableCellContainer = ({
  children,
  align = "left",
  width,
  index,
  sx,
  onClick,
  disableSelectItems,
}: GroupedTableCellContainerProps) => {
  return (
    <TableCell
      onClick={onClick}
      align={align}
      valign="middle"
      sx={{
        width,
        paddingLeft: index === 0 && disableSelectItems ? "26px" : "5px",
        paddingRight: "5px",
        ...sx,
      }}
    >
      {children}
    </TableCell>
  );
};

export const GroupedTableCell = ({
  column,
  value,
  flairComponent,
  onClick,
  index,
  disableSelectItems,
}: Props) => {
  const defaultProps = {
    align: column?.align,
    width: column?.width,
    index,
    sx: column?.sx,
    onClick: () => onClick && onClick(),
    disableSelectItems,
  };

  /*
   create type property to GroupedTableColumn
   if renderering cells needs more conditions
  */
  if (column.isTimeline) {
    return (
      <GroupedTableCellContainer {...defaultProps}>
        {value}
      </GroupedTableCellContainer>
    );
  }

  return (
    <GroupedTableCellContainer {...defaultProps}>
      <CellContentContainer sx={{ justifyContent: column?.align || "start" }}>
        {flairComponent}
        {!column?.disableTooltip ? (
          <Tooltip title={value}>
            <TextContainer sx={{ maxWidth: column?.maxWidth || "unset" }}>
              {value}
            </TextContainer>
          </Tooltip>
        ) : (
          value
        )}
      </CellContentContainer>
    </GroupedTableCellContainer>
  );
};
